import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
  private isRealMobileDevice(): boolean {
    const ua = navigator.userAgent || navigator.vendor;

    const isMobileUA = /android|iphone|ipad|ipod/i.test(ua);

    const isTouch = navigator.maxTouchPoints > 1;

    const isDesktopOS = /windows|macintosh|linux/i.test(ua);

    return isMobileUA && isTouch && !isDesktopOS;
  }

  isMobileOrTabletAcivePwa(): boolean {
    const isMobileOrTablet = this.isRealMobileDevice();
    return isMobileOrTablet && environment.activePWA;
  }
}
